<div class="row">
  <div class="col-12 col-lg-3 py-1">
    <app-read-only-static
      [value]="('enums.authorTypeEnum.' + author.type) | translate"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-6 col-xl-7 py-1">
    @switch (author.type) {
      @case (AuthorTypeEnum.TEAM_MEMBER) {
        <app-read-only-static
          [link]="('/administration/team-members/' + (author.team_member_id ?? ''))"
          [value]="(author.team_member?.first_name ?? '') + ' ' + (author.team_member?.last_name ?? '')"
        ></app-read-only-static>
      }
      @case (AuthorTypeEnum.EXTERNAL) {
        <app-read-only-static [value]="author.name"></app-read-only-static>
      }
    }
  </div>
  <div class="col-12 col-lg-3 col-xl-2 py-1 d-flex gap-2">
    <button
      *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_AUTHOR_DELETE_ALL]"
      class="btn btn-danger w-100"
      (click)="delete()"
    >{{ 'authenticated.administration.publications.edit.authors.delete.btn' | translate }}</button>
  </div>
</div>

<ng-template #confirmModal>
  <div class="modal-body text-center">
    <p>{{ 'components.delete_card.confirm_modal.title' | translate }}</p>
    <button type="button" class="btn btn-outline-danger me-3" (click)="confirmDelete()" >
      {{ 'components.delete_card.confirm_modal.confirm' | translate }}
    </button>
    <button type="button" class="btn btn-secondary ms-3" (click)="confirmModalRef?.hide()" >
      {{ 'components.delete_card.confirm_modal.cancel' | translate }}
    </button>
  </div>
</ng-template>
